import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";

import {
  AutoComplete,
  FormContainer,
  FormEmojiTextInput,
  FormInput,
  ISelectType,
  useFetch,
} from "@4uhub/lib4uhub";

import TicketServMessageService from "../../../../../services/ticketServiceMessage.service";
import TicketServService from "../../../../../services/ticket.service";
import MainApiService from "../../../../../services/mainApi.service";
import {
  TNewTicketServiceMessageForm,
  newTicketServiceMessageSchema,
} from "./NewTicketServiceMessageSchema";

const ticketServMessageService = new TicketServMessageService();
const ticketService = new TicketServService();

const GENERICS_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const genericsService = new MainApiService<ISelectType>(GENERICS_ROUTE);

const translationPath = "chatBot.page.service.ticketServiceMessage.";

const NewTicketServiceMessage = () => {
  const { t } = useTranslation();

  const [ticketServicesOptions, setTicketServiceOptions] = useState<
    ISelectType[]
  >([]);
  const [targetOptions, setTargetOptions] = useState<ISelectType[]>([]);

  const { sendRequest: save, loading: sLoading } = useFetch(
    ticketServMessageService.create
  );

  const { sendRequest: ticketServiceList } = useFetch(
    ticketService.listTicketServiceInMessages
  );

  const { sendRequest: genericList } = useFetch(genericsService.list);

  const fetchTicketServiceOptions = useCallback(async () => {
    const { data, success } = await ticketServiceList(undefined);
    if (data && success) {
      setTicketServiceOptions(data);
    }
  }, [ticketServiceList]);

  const fetchTargetOptions = useCallback(async () => {
    const { data, success } = await genericList({
      Identifier: "TicketServiceMessageTarget",
    });
    if (data && success) {
      setTargetOptions(data);
    }
  }, [genericList]);

  useEffect(() => {
    fetchTicketServiceOptions();
    fetchTargetOptions();
  }, [fetchTicketServiceOptions, fetchTargetOptions]);

  const handleSave = (v: TNewTicketServiceMessageForm) => {
    return save({
      ticketServiceId: v.ticketService.id,
      targetId: v.target.id,
      messageType: v.messageType,
      message: v.message,
    });
  };

  return (
    <FormContainer<TNewTicketServiceMessageForm>
      saveFunction={handleSave}
      loading={sLoading}
      title={t(translationPath + "ticket_service_message")}
      subtitle={t(translationPath + "ticket_service_message")}
      schema={newTicketServiceMessageSchema}
      fields={() => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <AutoComplete
              name="ticketService"
              label={t(translationPath + "ticket_service")}
              size="small"
              options={ticketServicesOptions}
              getOptionLabel={(option) => option.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AutoComplete
              name="target"
              label={t(translationPath + "target")}
              size="small"
              options={targetOptions}
              getOptionLabel={(option) => option.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormInput
              size="small"
              name="messageType"
              label={t(translationPath + "message_type")}
              fullWidth
              inputProps={{ style: { textTransform: "uppercase" } }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormEmojiTextInput
              size="small"
              name="message"
              label={t(translationPath + "message")}
              fullWidth
              multiline
              minRows={4}
            />
          </Grid>
        </Grid>
      )}
    />
  );
};

export default NewTicketServiceMessage;
